/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchTimeOffs} from '../api'

export const useMutationSearchTimeOffs = createReactQueryMutationHook('searchTimeOffs', searchTimeOffs)
